export const TableOrListStyleFunctiontyleOneReset = {
  ".multipage-table-section": {
    padding: "50px 0",
    "background-color": { r: 255, g: 255, b: 255, a: 100 },
  },
  ".multipage-table-section.bg-image": {},
  ".multipage-table-section.bg-image::before": {},
  ".multipage-table-section .section-title-area": {
    "margin-bottom": "50px",
  },
  ".multipage-table-section .section-title-area .section-subtitle": {
    "font-size": "16px",
    "font-weight": "600",
    color: { r: 255, g: 73, b: 124, a: 100 },
    "background-color": { r: 255, g: 73, b: 124, a: 0.2 },
    padding: "5px 20px",
    p1: "5px",
    p2: "20px",
    "border-radius": "15px",
    "margin-bottom": "15px",
    display: "inline-block",
  },
  ".multipage-table-section .section-title-area .section-title": {
    "font-size": "44px",
    "font-weight": "600",
    color: { r: 0, g: 0, b: 0, a: 100 },
  },
  ".multipage-table-section .custom-img": {
    width: "40px",
    height: "40px",
    "border-radius": "50%",
  },
  ".multipage-table-section .table th": {
    border: "1px solid rgba(204, 204, 204, 1)",
    borderPx: "1px",
    borderThik: "solid",
    borderColor: { r: 204, g: 204, b: 204, a: 100 },
  },
  ".multipage-table-section .table td": {
    border: "1px solid rgba(204, 204, 204, 1)",
    borderPx: "1px",
    borderThik: "solid",
    borderColor: { r: 204, g: 204, b: 204, a: 100 },
  },
  custom: "",
};
